import {NgModule} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MatSelectModule} from '@angular/material/select';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatGridListModule} from '@angular/material/grid-list';
import {ContentModule} from '../../../shared/directives/content.module';
import {SelectSearchDataComponent} from './select-search-data.component';
import {TextOverflowModule} from '../../../shared/directives/text-overflow.module';

@NgModule({
    declarations: [
        SelectSearchDataComponent
    ],
    exports: [
        SelectSearchDataComponent,
        ContentModule,
    ],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        MatSelectModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatIconModule,
        NgxMatSelectSearchModule,
        MatSlideToggleModule,
        CommonModule,
        MatGridListModule,
        MatButtonModule,
        ContentModule,
        TextOverflowModule
    ]
})
export class SelectSearchDataModule {}
